import React, { useEffect, useState } from "react";
import { App } from "../../../App";
import { HorizontalStack, SmartContainer, Stack } from "../../../styles/Containers";
import { StyledButton } from "../../../styles/matieralui/Button";
import { StyledStep, StyledStepContent, StyledStepLabel, StyledStepper } from "../../../styles/matieralui/Stepper";
import { StyledTimeline, StyledTimelineConnector, StyledTimelineContent, StyledTimelineDot, StyledTimelineItem, StyledTimelineSeparator } from "../../../styles/matieralui/Timeline";
import { StyledA, StyledH1, StyledH4, StyledH6, StyledImg, StyledP } from "../../../styles/StyledHTML";
import { jsRespondTo } from "../../../styles/Theme";
import { EmptyMessage } from '../../components/Empty/EmptyMessage';
import logo from '../../../assets/capturecollab-center-color-blue-icon.png';
import logoLeft from '../../../assets/logo-left-black-green.png';
import { FullLocations } from "../Location/redux/locations.selectors";
import { FullLibraries } from '../Library/redux/library.selectors';
import { Screen } from "../Photostream/Uploader";
import { TagSelector } from "../../../components/Taxonomy/TagSelector";
import { useDispatch } from "react-redux";
import { createLibrary, searchLibrary } from "../Library/redux/library.actions";
import { searchLocations } from "../Location/redux/locations.actions";
import { OnboardingLibraries } from "./OnboardingLibraries";
import { OnboardingLocations } from "./OnboardingLocations";
import { OnboardingPeople } from "./OnboardingPeople";
import { OnboardingTags } from "./OnboardingTags";
import { push } from "connected-react-router";
import { FormSelect } from "../../../components/Forms/FormSelect";
import { TERM_LIBRARY, TERM_LIBRARY_PLURAL } from "../../services/CaptureCollabService";


export const PageOnboarding = () => {

    const dispatch = useDispatch();
    const [activeStep, setActiveStep] = useState('type');
    const [type, setType] = useState(null);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const storeLibraries = FullLibraries();


    const steps = [
        {
            label: `Create Your First ${TERM_LIBRARY}`,
            description: `${TERM_LIBRARY_PLURAL} are the top most way of grouping assets.`
        },
        {
            label: "Add A Location",
            description: "Locations are common places you take photos."
        },
        {
            label: "Add A Person",
            description: "These people show up in a lot of photos. Let's make sure they are there from the beginning."
        },
        {
            label: "Create One Tag",
            description: "If you want to search it later, it best to set it up now."
        },
        {
            label: "Done!",
            description: "Let's get started uploading!"
        }
    ];

    const isMobile = jsRespondTo('mobile');
    const orientation = (isMobile) ? 'vertical' : 'horizontal';
    const aL = (!isMobile) ? true : false;

    const runDone = () => dispatch(push('/'))


    return (
        // <App title="Onboarding">
        <Stack flex align="center" justify="center" padding={10} direction="column">

            <SmartContainer flex align="center" justify="center">
                <img src={logoLeft} alt="Capture Collab Logo" style={{ maxWidth: '200px', width: '76%', height: 'auto' }} />
            </SmartContainer>
            {/* <SmartContainer>
                <StyledP light textAlign="center">Welcome! Let's take 1 minute to learn some terms and get your account set up.</StyledP>
                <br />
            </SmartContainer> */}
            {activeStep === 'type' && (
                <SmartContainer textAlign="center">
                    <StyledH6 light>Let's start by setting up your Workspace</StyledH6>
                    <br />
                    <StyledP>What best describes your organization?</StyledP>
                    <br />
                    <FormSelect label="Type" value={type} onChange={setType}>
                        <option key="default" value="default" selected disabled>Select Your Oranization Type</option>
                        <option key="agency" value="agency">Agency</option>
                        <option key="brand" value="brand">Brand</option>
                        <option key="church" value="church">Church</option>
                        <option key="marketer" value="marketer">Digital Marketer</option>
                        <option key="photographer" value="photographer">Photography Studio</option>
                        <option key="product" value="product">Product</option>
                        <option key="other" value="other">Other</option>
                    </FormSelect>
                    <br /><br />
                    <StyledButton disabled={(!type)} variant="contained" color="blue" onClick={() => setActiveStep(0)}>Begin</StyledButton>
                </SmartContainer>
            )}

            {activeStep !== 'type' && (
                <SmartContainer textAlign="center">
                    <StyledStepper orientation={orientation} alternativeLabel={aL} activeStep={activeStep}>
                        {steps.map((step, index) => (
                            <StyledStep key={step.label}>
                                <StyledStepLabel>{step.label}</StyledStepLabel>
                            </StyledStep>
                        ))}
                    </StyledStepper>
                </SmartContainer>
            )}

            <br /><br />
            {activeStep === 0 && (<OnboardingLibraries type={type} onBack={() => setActiveStep('type')} onComplete={() => setActiveStep(1)} />)}

            {activeStep === 1 && (<OnboardingLocations type={type} onComplete={() => setActiveStep(2)} />)}

            {activeStep === 2 && (<OnboardingPeople type={type} onComplete={() => setActiveStep(3)} />)}

            {activeStep === 3 && (<OnboardingTags type={type} onComplete={() => setActiveStep(4)} />)}

            {activeStep === 4 && (
                <Screen>
                    <SmartContainer textAlign="center" maxWidth="600px">
                        <StyledH1>🎉</StyledH1>
                        <StyledH6>Congrats! You are all set up.</StyledH6>
                        <StyledP>Let's take a look around your new Workspace. When you upload photos, you'll be able to choose from the tags you just setup and add new ones too.</StyledP>
                        <br />
                        <StyledButton variant="contained" color="blue" onClick={runDone}>Start Uploading</StyledButton>
                    </SmartContainer>
                </Screen>
            )}
        </Stack>
        // </App >
    )
}